// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"name":"collection.list","icon":"gift","path":"/list","parentId":"ant-design-pro-layout","id":"3"},"4":{"name":"collection.stock-log","icon":"transaction","path":"/stock-log","parentId":"ant-design-pro-layout","id":"4"},"5":{"name":"user.list","icon":"user","path":"/user-list","parentId":"ant-design-pro-layout","id":"5"},"6":{"name":"settings","icon":"setting","path":"/settings","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/","redirect":"/list","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"*","layout":false,"id":"8"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__table-list__index" */'@/pages/table-list/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__stock-log__index" */'@/pages/stock-log/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__user-list__index" */'@/pages/user-list/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__settings__index" */'@/pages/settings/index.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/Users/zhixinyang/项目/richer-admin/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
